"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var GasEnergy = function (_a) {
    var fill = _a.fill, props = __rest(_a, ["fill"]);
    return (React.createElement("svg", __assign({ fill: "none", viewBox: "0 0 24 24", width: "1em", height: "1em" }, props),
        React.createElement("path", { d: "m16.664 16.6.6-.8-1.599-1.2-.6.8c-.75.997-1.856 1.6-3.065 1.6h-1v2h1c1.905 0 3.58-.955 4.664-2.4z", fill: fill || 'currentColor' }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 3a1 1 0 0 0-1.316-.949c-1.55.517-2.662 1.243-3.287 2.199-.65.995-.673 2.084-.346 3.066.21.63.2 1.383-.022 1.932C9.83 9.746 9.51 10 9 10c-.313 0-.77-.233-1.074-.754-.28-.482-.369-1.124-.032-1.799A1 1 0 0 0 6.4 6.2C4.148 7.889 3 10.185 3 13a9 9 0 1 0 18 0c0-1.581-.44-2.738-1.147-3.651-.632-.817-1.456-1.399-2.149-1.888l-.126-.09c-.759-.537-1.374-.997-1.826-1.631C15.323 5.139 15 4.316 15 3zm-3.051 3.684c-.173-.518-.133-.95.122-1.34.178-.272.5-.583 1.05-.886.173.977.524 1.772 1.002 2.443.673.944 1.558 1.578 2.299 2.103l.044.031c.762.54 1.36.964 1.806 1.538.418.54.728 1.258.728 2.427a7 7 0 1 1-14 0c0-1.29.297-2.413.9-3.386.081.225.181.439.299.64C6.77 11.234 7.813 12 9 12c1.491 0 2.447-.917 2.885-2.005.417-1.037.406-2.283.064-3.311z", fill: fill || 'currentColor' })));
};
exports.default = GasEnergy;
